import { render } from "./TheFleetDetails.vue?vue&type=template&id=22cdaf35"
import script from "./TheFleetDetails.vue?vue&type=script&lang=js"
export * from "./TheFleetDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__